var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.authToken)?_c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":_vm.include}},[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }